import {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
  type ReactNode,
} from "react";
import {
  applyTheme,
  DEFAULT_THEME,
  readTheme,
  themes,
  THEME_STORAGE_KEY,
  THEME_SWITCHER_ENABLED,
  type ThemeId,
} from "../data/themes";

const ThemeContext = createContext({
  theme: themes.find((theme) => theme.id === DEFAULT_THEME)!,
  nextTheme: () => {},
});

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [savedId, setId] = useState<ThemeId>(readTheme);
  const id = THEME_SWITCHER_ENABLED ? savedId : DEFAULT_THEME;
  const theme = themes.find((item) => item.id === id)!;
  useLayoutEffect(() => {
    applyTheme(id);
  }, [id]);
  const nextTheme = () => {
    if (!THEME_SWITCHER_ENABLED) return;
    const next =
      themes[(themes.findIndex((item) => item.id === id) + 1) % themes.length];
    setId(next.id);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, next.id);
    } catch {
      /* The switcher still works without storage. */
    }
  };
  return (
    <ThemeContext.Provider value={{ theme, nextTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
